import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m13 2-2 2.5h3L12 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 14v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 14v-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12 22v-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PlugZap2";
const PlugZap2 = memo(themed(Icon));
export {
  PlugZap2
};
//# sourceMappingURL=plug-zap-2.js.map
